import React from 'react';

function LoggedOut(props) {
    return (
        <div style={{width:'fit-content',padding:'10px', display:'none'}}>
            Sign in
        </div>
    );
}

export default LoggedOut;